<template>
  <HPopup class="h-backpack-popup"
          ref="popup"
          v-show="visible">
    <div class="h-backpack-popup-body">
      <div class="h-backpack-header">{{ popupTitle }}</div>

      <div class="backpack-items h-outer-border around-4 bw4 bz0 h-bg brown-2">
        <div class="backpack-item-row"
             v-for="row in grids">
          <div class="backpack-item h-outer-border around-4 bw2 bz0"
               :class="[backpackItemClassName(col), col && col.id === selectedId ? 'selected' : '']"
               v-for="col in row"
               @click="selectBackpackItem(col)">
            <template v-if="col">
              <div class="item-icon h-effect"
                   :class="[`quality-${col.quality || ''}`, isEquipment(col.artifactId) ? 'equipment' : '', ignoreArtifact.includes(col.id) ? 'disabled' : '']"
                   v-if="col">
                <img class="artifact-icon" :src="cargoUrl(col.sourceName)" alt="">
                <div class="amount">{{ col.amount }}</div>

                <div v-if="col.slot === 9 && col.level > 0"
                     class="treasure-star">
                  <img class="icon-treasure-star"
                       :src="`${$rHost}/img/common/icon_treasure_lv_${col.level}.png`"
                       alt="">
                </div>
              </div>
              <HArtifactInfoBox :artifact-info="col" :showUseHelp="false"></HArtifactInfoBox>
            </template>
          </div>
        </div>
      </div>

      <div class="pager" v-if="backpackItems.length > pageSize">
        <button v-click-sound-button class="h-btn normal prev"
                :disabled="page <= 0"
                @click="handlePagePrev">上一页
        </button>
        <button v-click-sound-button class="h-btn normal next"
                :disabled="page >=1"
                @click="handlePageNext">下一页
        </button>
      </div>

      <div class="footer">
        <button ref="button"
                v-click-sound-button
                :disabled="!selectedId"
                class="h-button ok"
                @click="handleSubmit">
        </button>
        <button ref="button"
                v-click-sound-button
                class="h-button close"
                @click="handleClose">
        </button>
      </div>
    </div>
  </HPopup>
</template>

<script>
import HPopup from '@/components/h-popup/index.vue'
import { mapGetters, mapActions } from 'vuex'
import API from '@js/api'
import HArtifactInfoBox from '@/components/h-artifact-info-box'

export default {
  data () {
    return {
      rowNum: 5,
      colNum: 8,
      avatarItem: null,
      page: 0,
      backpackItems: [],
      selectedId: null,
    }
  },

  props: {
    visible: {
      type: Boolean,
      default: true
    },
    zIndex: {
      type: Number,
      default: 1000
    },
    artifactId: {
      type: Number,
    },
    popupTitle: {
      type: String,
      default: ''
    },
    ignoreArtifact: {
      type: Array,
      default () {
        return []
      }
    }
  },

  computed: {
    ...mapGetters('device', [
      'isMobile',
      'isMobileDevice',
    ]),

    pageSize () {
      return this.rowNum * this.colNum
    },

    grids () {
      const res = Object.assign(
        [],
        new Array(this.rowNum * this.colNum).fill(null),
        this.backpackItems.slice(this.page * this.pageSize, (this.page + 1) * this.pageSize))
      return new Array(this.rowNum).fill(null).map((v, i) => {
        return res.slice(this.colNum * i, this.colNum * (i + 1))
      })
    },

    selectedArtifact () {
      return this.backpackItems.find((item) => item.id === this.selectedId)
    },
  },

  async mounted () {
    this.$refs.popup.$el.style.zIndex = this.zIndex
    this.getBackpackItems()
  },

  methods: {
    ...mapActions('hero', [
      'getHeroInfo',
      'getHeroWore',
      'getPrimarySkills',
      'getSecondarySkills',
    ]),

    ...mapActions('user', [
      'getUserInfo'
    ]),

    ...mapActions('gameSocket', [
      'appendSystemMessage'
    ]),

    cargoUrl (sourceName) {
      return `${this.$rHost}/img/artifact/${sourceName}`
    },

    handleSubmit () {
      this.$emit('submit', JSON.parse(JSON.stringify(this.selectedArtifact || '{}')))
    },

    handleClose () {
      this.$emit('close', false)
    },

    handlePagePrev () {
      this.page = Math.max(this.page - 1, 0)
    },

    handlePageNext () {
      this.page = Math.min(this.page + 1, 2)
    },

    isEquipment (id) {
      return id > 1000 && id < 3000
    },

    backpackItemClassName (item) {
      if (!item) {
        return ''
      }
      return `quality-${item.quality || ''} ${this.isEquipment(item.artifactId) ? 'is-equipment' : ''}`
    },

    async getBackpackItems () {
      try {
        this.backpackItems = await API.hero.getBackpackItems({
          artifactId: this.artifactId,
        })
      } catch (err) {
        this.$message(err)
      }
    },

    async selectBackpackItem (item) {
      try {
        if (!item) {
          return
        }
        if (this.ignoreArtifact.includes(item.id)) {
          return
        }
        this.selectedId = item.id
      } catch (err) {
        this.$message(err)
      }
    }
  },

  components: {
    HPopup,
    HArtifactInfoBox,
  }
}
</script>

<style lang="stylus" scoped>
.pager
  margin-top 5px
  display flex
  justify-content flex-end
  .h-btn
    margin-left 5px
    font-size 12px
    width 54px
    height 25px

.backpack-items
  margin-top 2px
  padding 3px
  .backpack-item-row
    display flex
    .backpack-item
      position relative
      overflow visible
      margin 1px
      width 40px
      height 40px
      padding 1px
      user-select none
      &:hover
        z-index 1
        .item-icon
          border-color $colorGold
        .h-artifact-info-box
          display block
      &.selected
        z-index 2
        outline 2px solid $colorYellow
      .item-icon
        position relative
        display flex
        justify-content center
        align-items center
        padding 1px
        height 100%
        border 1px solid transparent
        &.disabled
          opacity 0.75
          cursor not-allowed
          filter grayscale(0.75)
        > img
          width 100%
          vertical-align top
        .amount
          position absolute
          z-index 1
          width 100%
          padding-right 2px
          left 0
          bottom 0
          font-size 12px
          text-align right
          whiteText1()
      .treasure-star
        position absolute
        z-index 2
        display flex
        align-items center
        justify-content center
        top 0
        right -2px
        height 12px
        .level-text
          line-height 12px
          font-size 12px
          font-weight bold
          color orange
          transform scale(0.833)
          text-shadow 0 0 1px #fff, 0 1px 1px #212121
        .icon-treasure-star
          width 20px
          height 10px
      .item-info
        display none
        position absolute
        width 210px
        top -5px
        left 50%
        transform translate(-50%, -100%)
        padding 5px
        border 1px solid #000
        letter-spacing 1px
        text-align left
        outline 1px solid #f7df7b
        white-space normal
        text-shadow 1px 1px 1px #000
        background-color rgba(74, 45, 23, 1)
        background-image imgURL("/img/bg/bg_brown_2.jpg")
        .name
          line-height 16px
          font-size 12px
          whiteText1()
        .effect
          margin-top 5px
          line-height 16px
          font-size 12px
          whiteText1()
        .desc
          width 120%
          margin-top 5px
          line-height 14px
          font-size 12px
          transform-origin left center
          transform scale(0.8333)
          whiteText1()
          opacity .75
        .help
          width 120%
          margin-top 2px
          line-height 14px
          font-size 12px
          transform-origin left center
          transform scale(0.8333)
          whiteText1()
          opacity .5

.h-backpack-header
  padding 5px 0
  text-align center
  letter-spacing 5px
  goldText()

.footer
  display flex
  justify-content space-evenly
  margin-top 10px
  text-align center
  > button
    width 72px
    height 36px
    box-sizing content-box
    border 2px solid $colorGold

</style>
